import Game from './game/Game';
import './App.css';

function App() {<h1>Snake</h1>
  return <Game />;
}

export default App;
